import { render, staticRenderFns } from "./companyCardList.vue?vue&type=template&id=9dc2ce1c&scoped=true"
import script from "./companyCardList.vue?vue&type=script&lang=js"
export * from "./companyCardList.vue?vue&type=script&lang=js"
import style0 from "./companyCardList.vue?vue&type=style&index=0&id=9dc2ce1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc2ce1c",
  null
  
)

export default component.exports